// import React, { useState } from 'react';
// import './CricketLiveStream.scss';
// import ReactPlayer from 'react-player';

// type SportStatProps = {
//   eventID: string;
//   providerUrl?: string;
// };

// const CricketLiveStream: React.FC<SportStatProps> = (props) => {
//   const { eventID, providerUrl } = props;

//   return (
//     <div className="cricket-live-stream-ctn">
//       {providerUrl ? (
//         <ReactPlayer
//           className="react-player"
//           url={providerUrl}
//           width="100%"
//           height="100%"
//           controls
//         />
//       ) : (
//         <ReactPlayer
//           className="react-player"
//           url={`https://vid.dreamcasino.live/GetAPI.html?MatchID=${eventID}`}
//           width="100%"
//           height="100%"
//           controls
//         />
//       )}
//     </div>
//   );
// };

// export default CricketLiveStream;
import React, { useRef, useState } from 'react';

import './CricketLiveStream.scss';

type SportStatProps = {
  eventID: string;
  providerUrl?: string;
};

const CricketLiveStream: React.FC<SportStatProps> = (props) => {
  const { eventID, providerUrl } = props;

  return (
    <div className="cricket-live-stream-ctn">
      {providerUrl && providerUrl!== "-"  ? (
        <iframe
          id="fp_embed_player"
          src={providerUrl}
          scrolling="no"
          allowFullScreen={true}
          height="100%"
          width="100%"
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        ></iframe>
      ) : (
        <iframe
          title="mob-live-stream"
          allowFullScreen={false}
          src={`https://vid.dreamcasino.live/GetAPI.html?MatchID=${eventID}`}
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
          height="100%"
          width="100%"
        ></iframe>
      )}

      {/* {
        <video ref={videoRef} autoPlay muted controls loop width="100%">
          <source
            src={
              providerUrl ??
              `http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4`
            }
          />
        </video>
      }
      {isPictureInPictureAvailable && (
        <button
          onClick={() => togglePictureInPicture(!isPictureInPictureActive)}
        >
          {isPictureInPictureActive ? 'Disable' : 'Enable'} Picture in Picture
        </button>
      )} */}
    </div>
  );
};

export default CricketLiveStream;
